module.exports = __webpack_public_path__ + "img/afric.00ca803b.png";